export default __webpack_public_path__ + "static/media/BodyPart_00.5089f5bc.png";